import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GlobalSearchComponent } from './global-search.component';
import { GlobalSearchApiService } from './global-search.apiservice';
import {MatCardModule} from '@angular/material/card';
import { DatatableModule } from '../../shared/components/datatable/datatable.module';
import { SpecialDatatableModule } from '../../shared/components/special-datatable/special-datatable.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    GlobalSearchComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    DatatableModule,
    SpecialDatatableModule,
    TranslateModule
  ],
  providers: [GlobalSearchApiService]
})
export class GlobalSearchModule { }
